
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Chilblains(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Chilblains"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                Chilblains are the <b>painful inflammation of small blood vessels in your skin</b> that occur in response to repeated
                                    exposure to cold but not freezing air. Also known as pernio,  chilblains can cause itching, red patches, swelling and  blistering on your hands and feet.
                                </p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/chilblains/1.png")} alt="onycomycosis" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Symptoms</b></p>
                                <p>Small, itchy red areas on your skin, often on your feet or hands</p>
                                <p>Possible blistering or skin ulcers</p>
                                <p>Swelling of your skin</p>
                                <p>Burning sensation on your skin</p>
                                <p>Changes in skin color from red to dark blue, accompanied by pain</p>

                                <a className="links" href="https://en.wikipedia.org/wiki/Chilblains">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Chilblains;